// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1LRYa","legacyBtn":"MutateMid_legacyBtn__2Rc_p"};